import angular from 'angular';
import ComponentsModule from '../components-module.js';
import template from './code-spinner.html';

const COMPONENT_NAME = 'codeSpinner';

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,

    bindings: {
      spinnerDiameter: '@'
    },

    controller: () => {
      
    }
  });

export default COMPONENT_NAME;
